import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';


export type InfoModalprops = {
    modalTitleFormattedMessageId: string,
    modalTextFormattedMessageId: string,
    closeModal: Function
}

const InfoModal = (props: InfoModalprops) => (
    <div className="info-modal panel radius-rectangle">
        <div className="panel-header">
            <h2 className="bold-title">
                <FontAwesomeIcon icon={faInfoCircle} />
                <FormattedMessage id={props.modalTitleFormattedMessageId} />
            </h2>
            <button className="btn-close-modal" onClick={() => props.closeModal()} />
        </div>
        <div className="panel-content">
            <div className="modal-content align-left">
                <p className="text-light pre-line">
                    <FormattedMessage id={props.modalTextFormattedMessageId} />
                </p>
            </div>
        </div>
    </div>
);

export default InfoModal;